import i18n from './i18n';
import { ChartBoxGradient } from './models/index';

const chartOptions: gv.LineChartOptions = Object.freeze({
  curveType: 'function',
  legend: {
    position: undefined,
  },
  chartArea: { left: 50, top: 10, width: '90%', height: '85%' },
  lineWidth: 4,
  hAxis: {
    title: i18n.RATE_PERIOD(30),
  },
  vAxis: {
    gridlines: {
      color: '#eeeeee',
    },
    textPosition: 'out',
    textStyle: {
      color: '#bbb',
      italic: true,
    },
  },
});

const chartGradientOptions: ChartBoxGradient = Object.freeze({
  id: 'chartGradient',
  x1: '0%',
  y1: '0%',
  x2: '100%',
  y2: '0%',
  stops: [{
    offset: '0%',
    'stop-color': '#79cdcc',
  }, {
    offset: '100%',
    'stop-color': '#8fe2a0',
  }],
});

export { chartOptions, chartGradientOptions };
